import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ABUtils, DateUtils, ErrorUtils } from '../../../utils';
import Field from './Field';
import { FieldType, TripType } from '../../../models';
import { DatesFragment } from '../MobileFragments';
import { ConnectedSegmentDate } from '../Segment/SegmentDate';
import { useSegmentContext } from '../Segment/SegmentManager/Context';
import { isTrainsProductActive, getTripType, getSegmentById } from '../../../redux/currentSearch/selectors';

const formatDepartureTime = (time) => {
    if (!time || time.length < 4) return '';
    return `${time.slice(0, 2)}:${time.slice(2, 4)}`;
};

export const DateField = () => {
    const { t } = useTranslation();
    const placeholder = t('flightsManager.placeholder.date.main');
    // TODO: update when format is clarified from UX
    const dateFormat = t('calendar.dateFormatOneLiner');

    const getErrorMessage = (error) =>
        t(ErrorUtils.getDatesErrorKey(error), ErrorUtils.getDatesErrorKeyArgs(error));

    const { segment } = useSegmentContext();
    const { id } = segment;

    const isTrainsProduct = useSelector(isTrainsProductActive);
    const { isSearchByHourMobile: isSearchByHourMobileAB } = ABUtils.getABs();
    const isSearchByHourMobile = isSearchByHourMobileAB && isTrainsProduct;
    const isOneWay = useSelector((state) => getTripType(state) === TripType.ONE_WAY);
    const segmentQuery = useMemo(() => ({ segmentId: id }), [id]);
    const departureTime = useSelector((state) => getSegmentById(state, segmentQuery)?.departureTime ?? null);

    const getDateWithTime = (dateValue) => {
        if (!dateValue) return '';
        const formattedDate = DateUtils.formatDate(dateValue, dateFormat);
        if (isSearchByHourMobile && isOneWay && departureTime) {
            return `${formattedDate} • ${formatDepartureTime(departureTime)}`;
        }
        return formattedDate;
    };

    return (
        <ConnectedSegmentDate segmentId={id}>
            {({ error, value }) => (
                <React.Fragment>
                    <Field
                        icon="calendar"
                        id={FieldType.DATE}
                        placeholder={placeholder}
                        value={getDateWithTime(value)}
                        errorMessage={getErrorMessage(error)}
                    />
                    <DatesFragment />
                </React.Fragment>
            )}
        </ConnectedSegmentDate>
    );
};
